"use strict";

export default function () {
    if (matchMedia('(min-width: 768px)').matches) {
        var mainNavItems = $('.js-touch-nav>li'),
            mainNavLinks = $('.js-touch-nav>li>a');

        mainNavLinks.on('touchstart', function (evt) {

            var parent = $(this).parent();

            if (!parent.hasClass('is-open')) {
                mainNavItems.removeClass('is-open');
                parent.addClass('is-open');
                evt.preventDefault();
                evt.stopImmediatePropagation();

                $('body').on('click', bodyClickHandler);
            }
        });

        function bodyClickHandler (evt) {
            if ($(evt.target).parents('.js-touch-nav').length < 1) {
                evt.preventDefault();
                mainNavItems.removeClass('is-open');
                $('body').off('click', bodyClickHandler);
            }
        }
    }
}